const trend = [
  require('assets/images/home/trend/1.png'),
  require('assets/images/home/trend/2.png'),
  require('assets/images/home/trend/3.png'),
  require('assets/images/home/trend/4.png')
];

export default trend;